var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "sc-page-base",
    { attrs: { title: _vm.title, loading: _vm.loading } },
    [
      _c("div", { staticClass: "columns" }, [
        _c(
          "div",
          { staticClass: "column" },
          [
            _c("sc-analytics-filters", {
              attrs: { loading: _vm.masterLoading },
              on: { "form-submit": _vm.onFormSubmit }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "columns" }, [
        _c(
          "div",
          { staticClass: "column" },
          [
            _c("sc-analytics-summary", {
              ref: "scAnalyticsSummary",
              staticClass: "page-recon-analytics__modules"
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "columns" }, [
        _c(
          "div",
          { staticClass: "column" },
          [
            _c("sc-analytics-monthly-revenue", {
              ref: "scAnalyticsMonthlyRevenue",
              staticClass: "page-recon-analytics__modules"
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "columns" }, [
        _c(
          "div",
          { staticClass: "column is-6" },
          [
            _c("sc-analytics-consolidated-lp", {
              ref: "scAnalyticsConsolidatedLp",
              staticClass: "page-recon-analytics__modules"
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "column is-6" },
          [
            _c("sc-analytics-status-recon", {
              ref: "scAnalyticsStatusRecon",
              staticClass: "page-recon-analytics__modules"
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "columns" }, [
        _c(
          "div",
          { staticClass: "column is-6" },
          [
            _c("sc-analytics-status-waiting-avaliation", {
              ref: "scAnalyticsWaitingAvaliation",
              staticClass: "page-recon-analytics__modules"
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "column is-6" },
          [
            _c("sc-analytics-status-release-payment", {
              ref: "scAnalyticsReleasePayment",
              staticClass: "page-recon-analytics__modules"
            })
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-546e0d72", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-546e0d72","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-recon/features/analytics/PageAnalytics.vue
// module id = null
// module chunks = 